// Lightweight debug logger that mirrors to console and localStorage
// Stores a rolling buffer of recent entries for later inspection in PROD

const STORAGE_KEY = 'debugLogs';
const MAX_ENTRIES = 300;

const safeStringify = (value) => {
    try {
        return JSON.stringify(value);
    } catch (_) {
        return String(value);
    }
};

const readLogs = () => {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
    } catch (_) {
        return [];
    }
};

const writeLogs = (logs) => {
    try {
        const pruned = logs.slice(Math.max(0, logs.length - MAX_ENTRIES));
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(pruned));
    } catch (_) {
        // ignore quota or serialization errors
    }
};

const push = (level, scope, message, meta) => {
    const entry = {
        ts: new Date().toISOString(),
        lvl: level,
        scope,
        msg: message,
        meta,
    };
    const logs = readLogs();
    logs.push(entry);
    writeLogs(logs);

    // Mirror to console for local/dev visibility
    const line = `[${entry.ts}] [${scope}] ${message}`;
    try {
        /* eslint-disable no-console */
        if (level === 'error') console.error(line, meta);
        else if (level === 'warn') console.warn(line, meta);
        else console.log(line, meta);
        /* eslint-enable no-console */
    } catch (_) {
        // no-op
    }
};

export const createLogger = (scope = 'app') => ({
    info: (message, meta) => push('info', scope, message, meta),
    warn: (message, meta) => push('warn', scope, message, meta),
    error: (message, meta) => push('error', scope, message, meta),
});

// Expose helpers for quick inspection in browser console
if (typeof window !== 'undefined') {
    window.DebugLogs = {
        get: () => readLogs(),
        clear: () => writeLogs([]),
        export: () => {
            const blob = new Blob([safeStringify(readLogs())], { type: 'application/json' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `debugLogs-${new Date().toISOString()}.json`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        },
    };
}

export default createLogger;
